import { JSX } from "react";
import { RegistrationField } from "./utils";
import { FormRegistrationData } from "./validationSchemas";


export const ValidationError = ({ fieldName, errors, showValidation }: { fieldName: RegistrationField, errors: FormRegistrationData, showValidation: boolean }): JSX.Element | null => {
    if (showValidation && errors?.[fieldName]) {
        return (
            <span className='error-message'>{errors?.[fieldName]}</span>
        )
    }
    return null;
}
